import { render } from "./ChatHeader.vue?vue&type=template&id=53666d67&scoped=true"
import script from "./ChatHeader.vue?vue&type=script&lang=js"
export * from "./ChatHeader.vue?vue&type=script&lang=js"

import "./ChatHeader.vue?vue&type=style&index=0&id=53666d67&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53666d67"]])

export default __exports__